interface ThinkingBarProps {
  active: boolean;
}

/**
 * A hairline that says work is happening.
 *
 * The concierge takes a few seconds to answer, and a button that only changes
 * its label reads as frozen — the wait was being reported as a hang. This is
 * the least that fixes it: two pixels of motion, no spinner, no overlay, no
 * region that appears and shoves the page around (the track holds its height
 * whether or not it is running).
 *
 * The tinted track carries the signal on its own, so under reduced motion —
 * where the travelling sliver is suppressed — there is still something to see.
 */
export default function ThinkingBar({ active }: ThinkingBarProps) {
  return (
    <div
      role="progressbar"
      aria-hidden={!active}
      aria-label={active ? "Building your watchlist" : undefined}
      className={`mt-2 h-0.5 overflow-hidden rounded-full transition-colors ${
        active ? "bg-squawk-blue/20" : "bg-transparent"
      }`}
    >
      {active && (
        <div className="h-full w-1/4 rounded-full bg-squawk-blue animate-indeterminate motion-reduce:animate-none motion-reduce:w-full motion-reduce:opacity-60" />
      )}
    </div>
  );
}
